// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications-list[data-v-423f2a9e]{max-height:350px;overflow-y:auto}.dropdown-item[data-v-423f2a9e]{white-space:normal}", ""]);
// Exports
module.exports = exports;
